export default __webpack_public_path__ + "static/Lia_V1@2x-a79cfbc5e044b42c3380435609f02c62.png";